import React from 'react';
const PORTRAIT_IMG = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesigne%202024%2FIMG_8523.jpeg500x500.jpeg&site=1856&w=300&h=400&user=1516&opt=w3';
export function PremierProgramsSection() {
  return <section className="py-16 md:py-24 bg-brand-gray-900 border-y border-brand-gray-800" data-id="element-806">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-807">
        <div className="text-center mb-12 md:mb-16 max-w-4xl mx-auto" data-id="element-808">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-809">
            Delivering Premier First Responder Programs Grounded in Our
            Expertise
          </h2>
          <div className="w-16 h-0.5 bg-brand-teal mx-auto" data-id="element-810" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center mt-12" data-id="element-811">
          <div className="lg:col-span-7 prose prose-invert prose-lg text-brand-gray-300 leading-relaxed" data-id="element-812">
            <p data-id="element-813">
              Medina Tactical Dynamics-Team APC is committed to providing
              training programs only in areas where we have direct, hands-on
              experience. As the owner and operator, I have observed an
              increasing trend in the industry where self-proclaimed
              "professional trainers" are teaching programs without substantial
              experience in the topics they present.
            </p>
            <p data-id="element-814">
              You can be assured that this will never be the case with our
              training. If we do not have the expertise in a particular area, we
              will not offer it to you. This is our unwavering commitment to
              you.
            </p>
          </div>
          <div className="lg:col-span-5 flex justify-center lg:justify-end" data-id="element-815">
            <div className="relative p-2 border border-brand-gray-700 bg-brand-black max-w-[300px]" data-id="element-816">
              <img src={PORTRAIT_IMG} alt="Jose Medina" className="block w-full h-auto object-cover" data-id="element-817" />
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-brand-teal z-10" data-id="element-818" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-brand-teal z-10" data-id="element-819" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-brand-teal z-10" data-id="element-820" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-brand-teal z-10" data-id="element-821" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}